import ModusServiceCollection from "../ModusServiceCollection";
import ResultDocumentModel from "../../models/modus/ResultDocumentModel";

/**
 * ResultDocument collection
 */
export default class ResultDocumentCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ResultDocumentModel;
  }

}
